import { writable } from 'svelte/store';

const games = {
      1: { id: 1, orderNumber: 1, name: "Hangman", image: "/images/game-promo-hangman_256.png", isLive: true,
        folderKey: "hangman",
        description: "With hangman you can have your viewers guess the word by guessing which letters are in the word. For each wrong guess the gallow is build and the persons body will be build. If the image is complete the viewers loose. If they guess it before the image is complete you have won. Each turn a timer will run and each user is able to give a suggestion for a letter, once the timer is over, the most chosen letter will be used as the letter to guess.",
        infoParticipationType: "Viewers as a group",
        infoParticipationMethod: "Viewer sends a command in chat",
        settingsStructure: [
          {
            "key":"guesses",
            "title":"Total Guesses",
            "description":"The amount of guesses before loss. This will have an impact on the hangman visualisation of the steps.",
            "controlType":"select",
            "options":[
              "7","10"
            ]
          },
          {
            "key":"timeToGuess",
            "title":"Time to Guess a letter",
            "description":"The amount of time in secconds per turn for the viewers/gamers to vote for a letter to guess.",
            "controlType":"select",
            "options":[
              "20","30","40","50","60","120","180","300","600"
            ]
          },
          {
            "key":"listToUse",
            "title":"List of Words",
            "description":"The list of words used for playing the game.",
            "controlType":"titleValueList",
            "data": [
              { "title": "Random", "value": "hangman_words_random.txt" },
              { "title": "Random - Entertainment", "value": "hangman_words_random_entertainment.txt" },
              { "title": "Random - Geography", "value": "hangman_words_random_geography.txt" },
              { "title": "Games", "value": "hangman_words_games.txt" },
              { "title": "Fantasy", "value": "hangman_words_fantasy.txt" },
              { "title": "Sport", "value": "hangman_words_sport.txt" },
              { "title": "F1", "value": "hangman_words_f1.txt" },
              { "title": "Toys", "value": "hangman_words_toys.txt" },
              { "title": "Movies", "value": "hangman_words_toys.txt" },
              { "title": "Series", "value": "hangman_words_series.txt" },
              { "title": "Brands", "value": "hangman_words_brands.txt" },
              { "title": "Countries & Cities", "value": "hangman_words_countries_cities.txt" },
              { "title": "Nature", "value": "hangman_words_nature.txt" },
              { "title": "Food", "value": "hangman_words_food.txt" },
              { "title": "Custom", "value": "custom.txt" }
            ]
          },
          {
            "key":"randomizeList",
            "title":"Randomize List",
            "description":"Should the list of words be played in a randomized order?",
            "controlType":"boolean"
          }
        ],
        themes: [
          {
            id: 1,
            title: "Flat Colored",
            previewImage: "hangman_flat_preview.png"
          },
          {
            id: 2,
            title: "Cartoon",
            previewImage: "hangman_flat_preview.png"
          },
          {
            id: 3,
            title: "White Chalk",
            previewImage: "hangman_flat_preview.png"
          },
          {
            id: 4,
            title: "Schoolboard",
            previewImage: "hangman_flat_preview.png"
          }
        ],
        monetize: [
          "You can add super votes using bits so that players can do a super vote for a letter, if that letter is the chosen letter for that turn and it is in the word their score will more points.",
          "You can include a vote scoring bonus for subscribed members. If they score twice the points per letter due to their subscription, it will make your viewers more likely to subscribe."
        ]

        
        },
      7: { id: 7, orderNumber: 7, name: "Pub Quiz", image: "/images/game-promo-trivia_256.png", isLive: true,
        folderKey: "pubquiz",
        description: "A customized Pub Quiz is a really fun way to start your stream. Ideal for getting your viewers and chatters connected to you before you start streaming your normal content or to give a fun and interactive break between your normal content sessions.",  
        infoParticipationType: "Viewers as a group",
        infoParticipationMethod: "Viewer sends a command in chat",
        settingsStructure: [
          {
            "key":"question_count",
            "title":"Total Questions",
            "description":"The amount of questions before the winner is declared.",
            "controlType":"select",
            "options":[
              "1","2","3","4","5","6","7","8","9","10","12","15","20","25","30","35","40","50","max"
            ]
          },
          {
            "key":"timeToGuess",
            "title":"Time to Guess a Question",
            "description":"The amount of time in secconds per turn for the viewers/gamers to vote for a letter to guess.",
            "controlType":"select",
            "options":[
              "20","30","40","50","60","120","180","300","600"
            ]
          },
          {
            "key":"questionsToUse",
            "title":"List of Questions",
            "description":"The list of questions used for playing the game. You can select precreated collections or create your own tailored to your audience. When adding your own, please use the format Question;Anwer1;Answer2;Answer3;Answer4 for each question on a separate line. Be sure to always provide 4 answers.",
            "controlType":"titleValueList",
            "data": [
              { "title": "Random", "value": "pubquiz_questions_random.txt" },
              { "title": "Random - Entertainment", "value": "pubquiz_questions_random_entertainment.txt" },
              { "title": "Random - Geography", "value": "pubquiz_questions_random_geography.txt" },
              { "title": "Games", "value": "pubquiz_questions_games.txt" },
              { "title": "Movies", "value": "pubquiz_questions_toys.txt" },
              { "title": "Series", "value": "pubquiz_questions_series.txt" },
              { "title": "Brands", "value": "pubquiz_questions_brands.txt" },
              { "title": "Fantasy", "value": "pubquiz_questions_fantasy.txt" },
              { "title": "Sport", "value": "pubquiz_questions_sport.txt" },
              { "title": "F1", "value": "pubquiz_questions_f1.txt" },
              { "title": "Toys", "value": "pubquiz_questions_toys.txt" },
              { "title": "Countries & Cities", "value": "pubquiz_questions_countries_cities.txt" },
              { "title": "Nature", "value": "pubquiz_questions_nature.txt" },
              { "title": "Food", "value": "pubquiz_questions_food.txt" },
              { "title": "Custom", "value": "custom.txt" }
            ]
          },
          {
            "key":"randomizeList",
            "title":"Randomize List",
            "description":"Should the list of questions be played in a randomized order?",
            "controlType":"boolean"
          }
        ],
        themes: [
          {
            id: 1,
            title: "Flat Colored",
            previewImage: "hangman_flat_preview.png"
          }
        ],
        monetize: [
          "You can add super votes using bits so that players can do a super vote for a letter, if that letter is the chosen letter for that turn and it is in the word their score will more points.",
          "You can include a vote scoring bonus for subscribed members. If they score twice the points per letter due to their subscription, it will make your viewers more likely to subscribe."
        ]
        },  
      2: { id: 2, orderNumber: 2, name: "Creature Battle", image: "/images/game-promo-creature-attack_256.png",  isLive: false,
        description: "With Creature Battle your viewers can create/choose a battle creature and use that to battle other viewers. Each viewer can customize their creature if they have a free viewers account and they can customize their battle strategy. Viewers can battle each other using their creature using chat commands or you can make viewers battle each other.",
        infoParticipationType: "Viewer vs Viewer",
        infoParticipationMethod: "Viewers sending command in chat or restricted where you can only initiate battles between viewers"  
       },
      3: { id: 3, orderNumber: 3, name: "Chess", image: "/images/game-promo-chess_crp_256.png", isLive: false,
        description: ""  },
      4: { id: 4, orderNumber: 4, name: "Checkers", image: "/images/game-promo-checkers_256.png", isLive: false,
        description: ""  },
      5: { id: 5, orderNumber: 5, name: "Slot Machine", image: "/images/game-promo-slotmachine_256.png", isLive: false, 
        description: ""  },
      6: { id: 6, orderNumber: 6, name: "Guess the Sound", image: "/images/game-promo-guess-sound_256.png", isLive: false, 
        description: ""  },
      
      8: { id: 8, orderNumber: 8, name: "Guess the Country", image: "/images/game-promo-guess-country_256.png", isLive: false, 
        description: ""  },
      9: { id: 9, orderNumber: 9, name: "Text RPG", image: "/images/game_text_based_rpg_256.png", isLive: false, 
        description: ""  },
      10: { id: 10, orderNumber: 10, name: "Tamagotchi", image: "/images/game_tamagotchi_256.png", isLive: false, 
        description: ""  },
      11: { id: 11, orderNumber: 11, name: "Riddle Master", image: "/images/game_riddle_master_256.png", isLive: false, 
        description: ""  },
      12: { id: 12, orderNumber: 12, name: "Hype Farm", image: "/images/game_riddle_master_256.png", isLive: false, 
        description: "Build a thriving farm with the help of your viewers. Let them use your streaming service functionality to cultivate, grow, farm and expand your farm."  },
      13: { id: 13, orderNumber: 13, name: "Boggle", image: "/images/game_riddle_master_256.png", isLive: false, 
        description: "Let users make up as many words as they can during streaming"  },
      14: { id: 14, orderNumber: 14, name: "Racing Top Down", image: "/images/game_riddle_master_256.png", isLive: false, 
        description: "Let users participate in the race and let them buy/get powerups and such similar to other race games as well."  },
      15: { id: 15, orderNumber: 15, name: "Quess the drawing", image: "/images/game_riddle_master_256.png", isLive: false, 
        description: "Make drawings and let your users guess the drawings"  },
      16: { id: 16, orderNumber: 16, name: "Daily Show", image: "/images/game_riddle_master_256.png", isLive: false, 
        description: "A collection of daily fun to do with your viewers. Will show a collection of unique games per day."  },

};

export const gameStore = writable(games);

export function getGame(id) {
    let game;
    gameStore.subscribe(games => {
        game = games[id] || null;
    })();
    return game;
}

export function getAllGames() {
    let allGames;
    gameStore.subscribe(games => {
        allGames = Object.values(games).sort((a, b) => a.orderNumber - b.orderNumber);
    })();
    return allGames;
}